import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from "@mui/material";
import { Edit } from "react-iconly";
import DoneIcon from "@mui/icons-material/Done";
import PageHeader from "./../../components/PageHeader";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Images } from "./../../assets/common";
import StarIcon from "@mui/icons-material/Star";
import ProfileBanner from "../../components/ProfileBanner";
import ArrowRow from "../../components/ArrowRow";
import SetSubscription from "../../components/SetSubscription";
import AddIcon from "@mui/icons-material/Add";
import { UserContext } from "./../../context/userContext";
import {
  fullName,
  getStreamingBalance,
  getUserDetail,
  truncate,
  updateUserDetail,
} from "./../../constants/function";
import ApiService from "./../../services/api-service";
import Loader from "../../components/Loader";
import MusicCard from "../../components/MusicCard";
import IosSwitch from "../../components/IOSSwitch";
import { addSongAction } from "./../../action/songs";
import { useDispatch } from "react-redux";
import AddMusicToPlaylist from "./../../components/AddMusicToPlaylist";
import { LoadingButton } from "@mui/lab";
import notifier from "../../components/Notifier";
import WarningPopup from "../../components/WarningPopup";
import { useTranslation } from "react-i18next";
import StreamPurchaseDialog from "../../components/StreamPurchase";
export default function Profile() {
  const { t } = useTranslation("common");
  // const { userData } = useContext(UserContext);
  const dispatch = useDispatch();
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const { id } = useParams();
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [check, setChecked] = React.useState(true);
  const [openWarning, setOpenWarning] = useState(false);
  const [fees, setFees] = useState(null);
  var userDetail = getUserDetail();
  const [changefee, handleFee] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [featuredArtist, setFeaturedArtist] = useState(null); // State to store featured artist data
  const [showStreamPurchase, setShowStreamPurchase] = useState(false);
  const [showOutOfStreamsPopup, setShowOutOfStreamsPopup] = useState(false);
  

  useEffect(() => {
    const getUserData = async () => {
      setLoading(true);
      try {
        const response = await ApiService.USER_PROFILE(id ? id : null);
        setLoading(false);
        // response["result"]["autoRenewal"] = response["result"]["hasPremium"];
        userDetail = Object.assign({}, response["result"]);
        updateUserDetail(userDetail);
        localStorage.setItem(
          "streamingBalance",
          response["result"]["streamingBalance"]
        );
        setUserData(response["result"]);
      } catch (error) {
        setLoading(false);
      }
    };
    if (userDetail) getUserData();
  }, []);
  useEffect(() => {}, [check, userData]);
  
  // Check if user is out of streams and show popup
  useEffect(() => {
    // Check both userData and localStorage for most up-to-date balance
    const currentBalance = userData?.streamingBalance || getStreamingBalance() || 0;
    console.log('Profile: Checking stream balance:', {
      userDataBalance: userData?.streamingBalance,
      localStorageBalance: getStreamingBalance(),
      currentBalance,
      willShowPopup: currentBalance <= 0
    });
    if (currentBalance <= 0) {
      setShowOutOfStreamsPopup(true);
    }
  }, [userData]);
  
  const handleStreamPurchaseComplete = (purchaseResult) => {
    // Update user data with new streaming balance
    setUserData(prev => ({
      ...prev,
      streamingBalance: purchaseResult.newStreamingBalance
    }));
    
    // Update localStorage
    localStorage.setItem("streamingBalance", purchaseResult.newStreamingBalance);
    
    // Close popups
    setShowOutOfStreamsPopup(false);
    setShowStreamPurchase(false);
    
    notifier.success(`Successfully purchased ${purchaseResult.streamsPurchased} streams!`);
  };
  
  const updateSubscription = async (c, fee) => {
    if (check) {
      setLoading(true);
      try {
        const response = await ApiService.UPDATE_SUBSCRIPTION({
          subscriptionFee: fee,
          subscriptionStatus: c ? "enabled" : "disabled",
        });
        const data = userData;
        data["subscriptionFee"] = fee;
        setUserData({ ...data });
        setLoading(false);
        setOpenWarning(false);
        setFees(null);
      } catch (error) {
        setLoading(false);
        setOpenWarning(false);
      }
    }
  };
  const checkFee = (c, fee) => {
    if (fee > userData["subscriptionFee"]) {
      setOpenWarning(true);
      setFees(fee);
    } else updateSubscription(c, fee);
  };
  const toggleMenu = (value, id, index) => {
    setSelectedAlbum(id);
    if (value && id) makeAction(value, id, index);
  };
  const makeAction = (key, id, index) => {
    switch (key) {
      case "m1":
        history.push(`/app/SongDetails/${id}`);
        break;

      case "m3":
        setShowPlaylist(true);
        break;

      case "m2":
        dispatch(addSongAction(userData["top5Music"][index], null, true));
        break;
      default:
        break;
    }
  };

  const updateRenewal = async () => {
    try {
      setLoad(true);
      const response = await ApiService.RENEWAL_SUBSCRIPTION_URL(
        !userData["autoRenewal"]
      );
      const data = userData;
      data["autoRenewal"] = !userData["autoRenewal"];
      setUserData({ ...data });
      updateUserDetail(data);
      setLoad(false);
    } catch (error) {
      setLoad(false);
    }
  };
  return (
    <Box>
      <Stack>
        <Stack position="relative">
          <ProfileBanner
            onUpdate={(user) => {
              setUserData({ ...user });
            }}
            userData={userData}
            // edit={true}
            loader={setLoading}
          />
         
          <Button
            onClick={() => history.push("/app/EditProfile")}
            className="__edit_profile_button"
            variant="outlined"
            title={t("myProfile.edit")}
            sx={{ whiteSpace: "pre" }}
          >
            {truncate(t("myProfile.edit"), 12)}
          </Button>
           {/* New Button to View Public Profile */}
           <Button
            variant="outlined"
            onClick={() => history.push(`/app/ArtistProfile/${userData._id}`)}
            sx={{
              fontSize: "12px",           // Make the font smaller
              padding: "5px 10px",         // Reduce padding
              width: "fit-content",        // Let the button size to its content
              marginTop: "10px",           // Add spacing from elements above
              marginBottom: "10px",        // Add spacing from elements below
              position: "relative",        // Position it relative to avoid overlapping
              color: 'var(--primary-color, #FFEE20)',
              borderColor: 'var(--primary-color, #FFEE20)',
              '&:hover': {
                borderColor: 'var(--primary-color, #FFE000)',
                backgroundColor: 'rgba(255, 238, 32, 0.04)'
              }
            }}
          >
            View Public Profile
          </Button>

        </Stack>
        {/* user name */}
        <Stack
          spacing={2}
          sx={{ textAlign: "center" }}
          className="_profile_alignment"
        >
          <Typography
            sx={{ fontSize: "17px !important" }}
            variant="body1"
          >
            {userData ? fullName(userData) : ""}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px !important",
              color: "text-fade",
              // padding: "0 100px",
            }}
            variant="body1"
          >
            {`${userData["bio"] ? userData["bio"] : ""}`}
          </Typography>
          {/* <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography sx={{ fontSize: 17 }} variant="body1" color="default">
              {`${userData["firstName"]} ${userData["lastName"]}`}
            </Typography>
            <IconButton
              className="_cp"
              onClick={() => history.push("/app/EditProfile")}
            >
              <Edit set="light" primaryColor="white" />
            </IconButton>
          </Stack> */}
          {/* <Box onClick={() => history.push("/app/Leaderboard")} className="_cp">
            <img
              src={Images.level}
              style={{ width: "100%", margin: "auto" }}
              alt=""
            />
            <Stack
              direction="row"
              gap="8px"
              alignItems="baseline"
              marginTop="-15px"
              sx={{ width: "fit-content", margin: "-15px auto 0" }}
            >
              {[
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20, 21, 22, 23, 24, 25, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
                12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
              ].map((m, index) => (
                <Box key={index} sx={{ position: "relative" }}>
                  <DoneIcon
                    className={
                      index < userData["avgLevel"]
                        ? "__level_graph"
                        : index == userData["avgLevel"]
                        ? "__level_graph1"
                        : "__level_graph2"
                    }
                  />
                  {index === userData["avgLevel"] ? (
                    <Stack
                      direction="row"
                      gap="2px"
                      sx={{
                        position: "absolute",
                        top: "-27px",
                        left: "-17px",
                        alignItems: "center",
                      }}
                    >
                      <Typography className="fs-13">
                        {t("myProfile.level")}{" "}
                      </Typography>
                      <Typography className="fs-14">
                        {userData["avgLevel"]}
                      </Typography>
                      <img
                        style={{ transform: "rotateZ(180deg)", height: "14px" }}
                        src={Images.back}
                        alt=""
                      />
                    </Stack>
                  ) : null}
                </Box>
              ))}
            </Stack>
          </Box> */}
          <Box direction="row" className="__profile_grid" gap="20px">
            <Stack
              className="__profile_card"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              onClick={() => history.push(`/app/Follow/${userData["_id"]}`)}
              sx={{
                padding: "0 10px",
                borderRadius: "8px",

                height: "82px",
                backgroundColor: "var(--paper-color, #1E1E1E)",
                border: "1px solid var(--accent-color, #262626)",
                cursor: "pointer",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  className="fs-17"
                  sx={{ color: 'var(--text-primary, #FFFFFF)' }}
                >
                  {userData["followerCount"]}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ color: 'var(--text-secondary, #B0B0B0)' }}
                >
                  {t("myProfile.followers")}
                </Typography>
              </Stack>
              <ArrowForwardIosRoundedIcon
                sx={{ fontSize: 18 }}
              />
            </Stack>
            <Stack
              className="__profile_card"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              onClick={() => history.push(`/app/Following/${userData["_id"]}`)}
              sx={{
                padding: "0 10px",
                borderRadius: "8px",
                height: "82px",
                backgroundColor: "var(--paper-color, #1E1E1E)",
                border: "1px solid var(--accent-color, #262626)",
                cursor: "pointer",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  className="fs-17"
                  sx={{ color: 'var(--text-primary, #FFFFFF)' }}
                >
                  {userData["followingCount"]}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ color: 'var(--text-secondary, #B0B0B0)' }}
                >
                  {t("myProfile.following")}
                </Typography>
              </Stack>
              <ArrowForwardIosRoundedIcon
                sx={{ fontSize: 18 }}
              />
            </Stack>
            <Box
              className="__profile_card"
              sx={{
                padding: "10px",
                borderRadius: "8px",
                // width: "444px",
                // backgroundColor: "#262626",
                backgroundColor: "var(--paper-color, #1E1E1E)",
                border: "1px solid var(--accent-color, #262626)",
                cursor: "pointer",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  border: "1px dashed var(--accent-color, #262626)",
                  padding: "6px",
                  borderRadius: "6px",
                  minHeight: "72px",
                }}
              >
                <Stack direction="column" spacing={1} alignItems="baseline">
                  <Stack direction="row" gap="5px" alignItems="center">
                    <Typography 
                      className="fs-17"
                      sx={{
                        color: 'var(--primary-color, #FFEE20)'
                      }}
                    >
                      {userData["hasPremium"]
                        ? t("myProfile.premium.header")
                        : t("myProfile.premium.header2")}
                    </Typography>
                    {userData["hasPremium"] ? (
                      <StarIcon
                        sx={{
                          color: "var(--secondary-color, #1E1E1E)",
                          backgroundColor: "#3BF005",
                          borderRadius: "50%",
                          fontSize: "14px",
                        }}
                      />
                    ) : null}
                  </Stack>

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography
                      variant="body2"
                      sx={{ color: 'var(--text-secondary, #B0B0B0)' }}
                    >
                      {t("myProfile.premium.subHeader")}:{" "}
                      <Typography 
                        component="span"
                        sx={{ 
                          color: (userData["streamingBalance"] || 0) <= 0 ? '#f44336' : 
                                (userData["streamingBalance"] || 0) <= 10 ? '#ff9800' : '#4caf50',
                          fontWeight: 'bold'
                        }}
                      >
                        {userData["streamingBalance"]
                          ? userData["streamingBalance"].toFixed(0)
                          : 0}
                      </Typography>
                    </Typography>
                    {((userData["streamingBalance"] || 0) <= 10) && (
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => setShowStreamPurchase(true)}
                        sx={{
                          backgroundColor: 'var(--primary-color, #FFEE20)',
                          color: 'var(--secondary-color, #1E1E1E)',
                          fontWeight: 'bold',
                          fontSize: '10px',
                          padding: '2px 8px',
                          minWidth: 'auto',
                          height: '24px',
                          '&:hover': {
                            backgroundColor: 'var(--primary-color, #FFE000)'
                          },
                          '&.Mui-disabled': {
                            backgroundColor: 'var(--primary-color, #FFEE20)',
                            opacity: 0.5,
                            color: 'var(--secondary-color, #1E1E1E)'
                          }
                        }}
                      >
                        Buy More
                      </Button>
                    )}
                  </Stack>
                </Stack>
                {userData["hasPremium"] ? (
                  <Stack direction="column" alignItems="flex-end">
                    <Typography
                      className="fs-14"
                      sx={{
                        display: "flex !important",
                        marginBottom: "revert !important",
                        color: "var(--text-secondary, #FFFFFF70)",
                      }}
                    >
                      $10/ month
                    </Typography>
                    <LoadingButton
                      loading={load}
                      loadingPosition="center"
                      variant="contained"
                      sx={{ 
                        height: "36px !important", 
                        whiteSpace: "pre",
                        backgroundColor: 'var(--primary-color, #FFEE20)',
                        color: 'var(--secondary-color, #1E1E1E)',
                        '&:hover': {
                          backgroundColor: 'var(--primary-color, #FFE000)'
                        }
                      }}
                      onClick={() => updateRenewal()}
                    >
                      {load
                        ? ""
                        : !userData["autoRenewal"]
                        ? t("myProfile.premium.buttonText2")
                        : t("myProfile.premium.buttonText1")}
                    </LoadingButton>
                  </Stack>
                ) : null}
              </Stack>
            </Box>
            <Box
              className="__profile_card"
              sx={{
                padding: "10px",
                borderRadius: "8px",
                // width: "444px",
                height: !changefee ? "auto" : "66px",
                minHeight: "80px",
                // backgroundColor: "#262626",
                backgroundColor: "var(--paper-color, #1E1E1E)",
                border: "1px solid var(--accent-color, #262626)",
                cursor: "pointer",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  height: !changefee ? "auto" : "53px",
                  minHeight: "84px",
                  border: "1px dashed var(--accent-color, #262626)",
                  borderRadius: "6px",
                }}
              >
                {userData["email"] ? (
                  <SetSubscription
                    checked={(c, fee) => checkFee(c, fee)}
                    subscription={userData}
                    changeFee={(e) => handleFee(e)}
                  />
                ) : null}
              </Stack>
            </Box>

            <Stack
              className="__profile_card"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              onClick={() => history.push(`/app/Albums`)}
              sx={{
                padding: "0 10px",
                borderRadius: "8px",
                // width: "444px",
                height: "82px",
                // backgroundColor: "#262626",
                backgroundColor: "var(--paper-color, #1E1E1E)",
                border: "1px solid var(--accent-color, #262626)",
                cursor: "pointer",
              }}
            >
              <Stack direction="row" spacing={1}>
                <Typography className="fs-17" sx={{ color: 'var(--text-primary, #FFFFFF)' }}>
                  {t("myProfile.albums")}
                </Typography>
              </Stack>
              <ArrowForwardIosRoundedIcon
                sx={{ fontSize: 18 }}
              />
            </Stack>

            <Stack
              className="__profile_card"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              onClick={() => history.push(`/app/Recordings`)}
              sx={{
                padding: "0 10px",
                borderRadius: "8px",
                // width: "444px",
                height: "82px",
                // backgroundColor: "#262626",
                backgroundColor: "var(--paper-color, #1E1E1E)",
                border: "1px solid var(--accent-color, #262626)",
                cursor: "pointer",
              }}
            >
              <Stack direction="row" spacing={1}>
                <Typography className="fs-17" sx={{ color: 'var(--text-primary, #FFFFFF)' }}>{t("recording")}</Typography>
              </Stack>
              <ArrowForwardIosRoundedIcon
                sx={{ fontSize: 18 }}
              />
            </Stack>
          </Box>

          <Stack spacing={1} sx={{ paddingBottom: "120px" }}>
            <Box sx={{ textAlign: "left" }}>
              <Typography
                component="span"
                variant="body1"
                className="fw-b text-white"
              >
                {t("myProfile.addFeatures")}
              </Typography>
              <Typography
                component="span"
                variant="body2"
                className="fade-text"
              >
                {" "}
                ({t("max")})
              </Typography>
            </Box>
            {userData["top5Music"] ? (
              <Stack spacing={1}>
                <Box
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                  }}
                >
                  <Box
                    sx={{
                      border: "2px dashed #4D4D4D !important",
                      borderRadius: "6px",
                      width: 210,
                      height: 210,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className="_cp"
                    onClick={() => history.push("/app/AddFeatureMusic")}
                  >
                    <AddIcon style={{ color: "#4D4D4D", fontSize: "50px" }} />
                  </Box>
                  {userData["top5Music"] &&
                    userData["top5Music"].map((music, index) => (
                      <MusicCard
                        isTopMusic={true}
                        isMusic={true}
                        key={index}
                        music={music}
                        actions={[
                          { key: "m2", action: t("dropMenu.m2") },
                          { key: "m3", action: t("dropMenu.m3") },
                          { key: "m1", action: t("dropMenu.m1") },
                        ]}
                        toggleMenu={(action, id) =>
                          toggleMenu(action, id, index)
                        }
                      />
                    ))}
                </Box>
              </Stack>
            ) : (
              <Box
                sx={{
                  border: "2px dashed #4D4D4D",
                  borderRadius: "6px",
                  width: 96,
                  height: 96,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => history.push("/app/AddFeatureMusic")}
              >
                <AddIcon style={{ color: "#4D4D4D", fontSize: "50px" }} />
              </Box>
            )}
          </Stack>
        </Stack>
      </Stack>
      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {openWarning ? (
        <WarningPopup
          fee={fees}
          changefee={changefee}
          isSubscribed={true}
          open={openWarning}
          message={t("warning.message2")}
          updateSubscription={(c, fee) => updateSubscription(c, fee)}
          handleClose={() => setOpenWarning(false)}
        />
      ) : null}
      
      {/* Stream Purchase Dialog */}
      <StreamPurchaseDialog
        open={showStreamPurchase}
        onClose={() => setShowStreamPurchase(false)}
        currentStreams={userData["streamingBalance"] || 0}
        onPurchaseComplete={handleStreamPurchaseComplete}
      />
      
      {/* Out of Streams Popup */}
      <Dialog 
        open={showOutOfStreamsPopup} 
        onClose={() => setShowOutOfStreamsPopup(false)}
        maxWidth="sm"
        PaperProps={{
          style: {
            backgroundColor: 'var(--paper-color, #1a1a1a)',
            color: 'var(--text-primary, #ffffff)',
            borderRadius: '16px',
            minWidth: '400px'
          }
        }}
      >
        <DialogTitle>
          <Typography
            variant="h6"
            sx={{ color: 'var(--error-color, #f44336)', fontWeight: 'bold' }}
          >
            🚫 Out of Streams!
          </Typography>
        </DialogTitle>
        
        <DialogContent>
          <Alert 
            severity="error" 
            sx={{ 
              backgroundColor: 'rgba(244, 67, 54, 0.1)',
              color: 'var(--error-color, #f44336)',
              border: '1px solid rgba(244, 67, 54, 0.3)',
              mb: 2
            }}
          >
            You've used up all your streaming allowance for this month.
          </Alert>
          
          <Typography variant="body1" sx={{ mb: 2 }}>
            To continue listening to music, you can:
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            • 💰 <strong>Purchase additional streams</strong> ($0.01 per stream + 4% fee)
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            • ⭐ <strong>Upgrade to Premium</strong> for 750 streams per month
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            • 📅 <strong>Wait for next month</strong> for your free streams to refill
          </Typography>
        </DialogContent>
        
        <DialogActions sx={{ padding: 3 }}>
          <Button
            onClick={() => setShowOutOfStreamsPopup(false)}
            sx={{ color: 'var(--text-secondary, #B0B0B0)' }}
          >
            Maybe Later
          </Button>
          <Button
            onClick={() => {
              setShowOutOfStreamsPopup(false);
              setShowStreamPurchase(true);
            }}
            variant="contained"
            sx={{
              backgroundColor: 'var(--primary-color, #FFEE20)',
              color: 'var(--primary-contrast-text, #000000)',
              fontWeight: 'bold',
              '&:hover': { backgroundColor: 'var(--primary-color, #FFE000)' }
            }}
          >
            Buy Streams Now
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
